<template>
  <div class="w-full">
    <!-- Tonaj null ise "Sipariş Bekliyor" -->
    <div v-if="item.tonnage === null && item.isEvacuationEnd != 1" class="flex items-center justify-start w-28 py-1 px-2">
      <span class="text-xs font-semibold text-yellow-500">Sipariş Bekliyor</span>
    </div>

    <!-- Tahliye manuel olarak tamamlanmışsa -->
    <div v-else-if="item.isEvacuationEnd == 1" class="flex items-center justify-start w-28 py-1 px-2">
      <div class="w-2 h-2 rounded-full bg-green-500 mr-1 animate-pulse"></div>
      <span class="text-xs font-semibold text-green-700">Tamamlandı</span>
    </div>

    <!-- Case for stateId 3 (Ready to start) -->
    <div v-else-if="item.stateId === 3">
      <!-- Show Button only if not completed (tonnage remaining) -->
      <div v-if="remainingTonnage > 0">
        <asyncBtn
          @click="startShip(item)"
          :loadState="loadState"
          text="Başlat"
          icon=""
          size="py-1"
          :containerClass="'bg-red-700 hover:bg-red-800 w-28 text-white text-xs font-semibold rounded'"
        />
      </div>
      <!-- Show Completed status if no tonnage remaining -->
      <div v-else>
        <div class="flex items-center justify-start w-28 py-1 px-2">
          <div class="w-2 h-2 rounded-full bg-green-500 mr-1"></div>
          <span class="text-xs font-semibold text-green-700">Tamamlandı</span>
        </div>
      </div>
    </div>

    <!-- Case for other stateIds -->
    <div v-else>
      <!-- Active/Started -->
      <div v-if="item.stateId === 1 && remainingTonnage > 0" class="flex items-center justify-start w-28 py-1 px-2">
        <div class="relative w-2 h-2 rounded-full bg-yellow-500 mr-1">
          <div class="absolute w-full h-full rounded-full bg-yellow-500 animate-ping opacity-75"></div>
        </div>
        <span class="text-xs font-semibold text-yellow-700">Aktif</span>
      </div>

      <!-- Completed -->
      <div v-else-if="item.stateId === 1 && remainingTonnage <= 0" class="flex items-center justify-start w-28 py-1 px-2">
        <div class="w-2 h-2 rounded-full bg-green-500 mr-1"></div>
        <span class="text-xs font-semibold text-green-700">Tamamlandı</span>
      </div>

      <!-- Stopped -->
      <div v-else-if="item.stateId === 2" class="flex items-center justify-start w-28 py-1 px-2">
        <span class="text-xs font-semibold text-gray-600">Kapalı</span>
      </div>

      <!-- Other states (possibly cancelled or undefined) -->
      <div v-else class="flex items-center justify-start w-28 py-1 px-2">
        <span class="text-xs font-semibold text-gray-600">İptal Edildi</span>
      </div>
    </div>
  </div>
</template>

<script>
import asyncBtn from "../../../../../components/general/asyncBtn.vue";

export default {
  name: "ShipEvacuationStatusCell",
  components: {
    asyncBtn
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    loadState: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    remainingTonnage() {
      if (!this.item.tonnage || this.item.tonnage === 0) {
        return 0;
      }
      return Math.max(this.item.tonnage - this.item.receivedTonnage, 0).toFixed(2);
    }
  },
  methods: {
    startShip(item) {
      this.$emit('start-ship', item);
    }
  }
};
</script>